import { render, staticRenderFns } from "./referral.vue?vue&type=template&id=5774d844&scoped=true&"
import script from "./referral.vue?vue&type=script&lang=ts&"
export * from "./referral.vue?vue&type=script&lang=ts&"
import style0 from "./referral.vue?vue&type=style&index=0&id=5774d844&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5774d844",
  null
  
)

export default component.exports